import { createStore } from 'vuex'
import axios from 'axios'
import { syncUiPrefsFromServer } from '@/helpers/uiPrefs.js'
import { refreshGroups, savedGroups, showGroups } from '@/helpers/myGroups.js'

export default createStore({
  
  state: {
    isAuthenticated: false,
    isLoading: false,
    isPlaning: false,
    isCashAccountant: false,
    token: null,
    user: null,
    errorLogin: null,
    activeURL: '',
    // userGroups: [],
  },

  getters: {
    isAuthenticated: state => state.isAuthenticated, 
    StateUser: state => state.user,
    isPlaning: state => state.isPlaning,
    isCashAccountant: state => state.isCashAccountant,
    
  },

  mutations: {
    
    // the sign-in this browser kept. How long it lasts is the server's call (24 hours from the last
    // sign-in): an expired token gets a 401 and main.js sends the user to the login page.
    initializeStore(state) {
      const token = localStorage.getItem('token')
      if (token) {
        axios.defaults.headers.common['Authorization'] = 'Token ' + token
        this.commit('setToken', token)
        this.commit('setUser', localStorage.getItem('user'))
      } else {
        this.commit('removeToken')
        this.commit('setUser', null)
        axios.defaults.headers.common['Authorization'] = ''
      }
      showGroups(this, token ? savedGroups() : [])
    },

    setIsLoading(state,status) {
      state.isLoading = status
    },

    setIsPlaning(state,status) {
      state.isPlaning = status
    },

    setIsCashAccountant(state,status) {
      state.isCashAccountant = status
    },

    setErrorLogin(state, error) {
      state.errorLogin = error
    },

    setUser(state, username){
      state.user = username
    },

    setToken(state, token) {
      state.token = token
      state.isAuthenticated = true
    },  

    removeToken(state) {
        state.token = ''
        state.isAuthenticated = false
    }, 


  },

  actions: {
    
    // errorLogin afterwards: {success: true}, the server's answer to a refused sign-in
    // (non_field_errors: wrong username or password), or {success: false, message} with no answer
    async LogIn (context, usercredentials) {
      // a token left from before must not ride along
      axios.defaults.headers.common['Authorization'] = ''
      let token
      try {
        const { data } = await axios.post('/api/v1/token/login', {
          username: usercredentials.username,
          password: usercredentials.password,
        })
        token = data.auth_token
      } catch (error) {
        context.commit('setErrorLogin', error.response ? error.response.data : { success: false, message: error.message })
        return
      }

      context.commit('setToken', token)
      context.commit('setUser', usercredentials.username)
      axios.defaults.headers.common['Authorization'] = 'Token ' + token
      localStorage.setItem('token', token)
      localStorage.setItem('user', usercredentials.username)
      // this user's display settings, from any computer they used before
      syncUiPrefsFromServer()
      try {
        await refreshGroups(context)
      } catch (error) {
        // no groups yet: the pages that need them ask again
      }
      context.commit('setErrorLogin', { success: true })
    },

    // the Sign out button: the server stops the token too (it is the user's one token, so their
    // other computers are signed out as well), then this browser forgets it
    async SignOut (context) {
      try {
        await axios.post('/api/v1/token/logout/')
      } catch (error) {
        // signed out here anyway; the server lets the token go after 24 hours
      }
      await context.dispatch('LogOut')
    },

    // forget the sign-in in this browser (also when the server answered 401: main.js)
    async LogOut (context) {
      context.commit('removeToken')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      // left by older builds, which kept the sign-in time here
      localStorage.removeItem('lastLogin')
      localStorage.removeItem('userGroups')
      axios.defaults.headers.common['Authorization'] = ''
      context.commit('setIsPlaning', false)
      context.commit('setIsCashAccountant', false)
      context.commit('setErrorLogin', { success: 'logout' })
    }

  },
  
  modules: {
  }

})
